import Component from "@tunnel-components/@sharded/@widgets/filtre-multiple/component";
import * as React from "react";
import { connect } from "react-redux";
import * as Utils from "@Cyclope-Utils/index";
import * as Lodash from "lodash";

/**
 * @class Container : Composant à état
 * @description : composant “complexe” recevant des props et possédant
 * un état interne pour générer son rendu.
 * @extends { React.PureComponent }
 * @implements
 * @method
 * @name onMouseEnter
 * @name onMouseLeave
 * @name
 * @name componentWillReceiveProps
 * @name render
 * @infos "https://reactjs.org"
 */

class Container extends React.PureComponent<any, any> {
  //  faire cette action toute les 100 millisecondes
  public debouceToggleSuggestion = Lodash.debounce(() => {
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any) => ({
      toggleSusggestion: false,
      isVisible: true,
    }));
  }, 100);
  //  faire cette action toute les 100 millisecondes
  public debouceMouseEnter = Lodash.debounce(() => {
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any) => ({ isVisible: true }));
  }, 100);
  //  faire cette action toute les 100 millisecondes
  public debouceMouseLeave = Lodash.debounce(() => {
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any) => ({
      isVisible: false,
      toggleSusggestion: true,
    }));
  }, 100);

  /**
   * @constructor
   * @description :
   * Le Constructor est invoqué en premier.
   * Il reçoit en argument toutes les props initiales du composant
   * Le Constructor est aussi utilisé pour Binder les events Handler à l’instance.
   * @param { objet <any> } props
   */
  public constructor(props: any) {
    /**
     * @function
     * @description : Utilisé afin d'appeler ou d'accéder
     * à des fonctions définies sur l'objet parent.
     */
    super(props);
    /**
     * @namespace
     * @description : possède des informations sur le composant
     * @property { object }       state
     */
    this.state = {
      isVisible: false,
      filter: [],
      selected: false,
      selectedString: [], // liste des eléments
      selectedFixeArray: [],
      selectedOptions: props.selectedOptions,
      toggleSusggestion: true,
    };
    /**
     * @description : Empêcher l'exécution des méthodes à chaque initialisation
     * des composants ; "seulement quand un event est exécuté"
     */
    this.onMouseEnter = this.onMouseEnter.bind(this);
    this.onMouseLeave = this.onMouseLeave.bind(this);
    this.onGetStringValue = this.onGetStringValue.bind(this);
    this.onSearchValue = this.onSearchValue.bind(this);
    this.onToggleSuggestion = this.onToggleSuggestion.bind(this); // action sur la liste des suggestions
    this.onClearAllElement = this.onClearAllElement.bind(this);
    this.onClearElement = this.onClearElement.bind(this);
  }
  /**
   * fermeture ou ouverture de la liste des suggestion
   * @method onToggleSuggestion
   * @param { any }  event
   * @infos "https://reactdatepicker.com/"
   */
  public onToggleSuggestion = (event: any): void => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.persist();
    /**
     * Afin d'améliorer la performance de l'interface on utilise des actions
     * espacé dans le temps
     */
    this.debouceToggleSuggestion();
  };

  /**
   * fermeture ou ouverture de la liste des suggestion
   * @method onClearElement
   * @param { any }  event
   * @param { string } param
   * @infos "https://reactdatepicker.com/"
   */
  public onClearElement = (param: string) => (event: any): void => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.preventDefault();
    /**
     * Afin d'améliorer la performance de l'interface on utilise des actions
     * espacé dans le temps
     */
    const index: number = this.state.selectedFixeArray.indexOf(param);

    /**
     * @constant
     * @name filter
     * @type boolean[]
     */
    const filter: boolean[] = this.state.filter;
    /**
     * @constant
     * @name selectedString
     * @type any[]
     */
    const selectedString: any[] = this.state.selectedString;

    // boucle

    selectedString[index] = "";
    filter[index] = false;

    {
      /** Empêcher la mutation du state */
    }
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any) => filter);
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any) => selectedString);
    {
      /** Empêcher la mutation du state */
    }
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any) => ({ selected: !this.state.selected }));
  };
  /**
   * fermeture ou ouverture de la liste des suggestion
   * @method onClearAllElement
   * @param { any }  event
   * @infos "https://reactdatepicker.com/"
   */
  public onClearAllElement = (event: any): void => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.preventDefault();
    /**
     * Afin d'améliorer la performance de l'interface on utilise des actions
     * espacé dans le temps
     */
    /**
     * @constant
     * @name filter
     * @type boolean[]
     */
    const filter: boolean[] = [];
    /**
     * @constant
     * @name selectedString
     * @type any[]
     */
    const selectedString: any[] = [];
    // boucle
    for (let i = 0; i < Math.ceil(this.state.selectedFixeArray.length); i++) {
      filter.push(false);
      // selectedString.push("");
    }
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any) => ({ filter, selectedString }));
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any) => ({ selected: !this.state.selected }));
  };

  /**
   * fermeture ou ouverture du calandrier
   * @method onMouseEnter
   * @param { any }  event
   * @infos "https://reactdatepicker.com/"
   */
  public onMouseEnter = (event: any): void => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.persist();
    /**
     * Afin d'améliorer la performance de l'interface on utilise des actions
     * espacé dans le temps
     */
    this.debouceMouseEnter();
  };
  /**
   * fermeture ou ouverture du calandrier
   * @method onMouseLeave
   * @param { any }  event
   * @infos "https://reactdatepicker.com/"
   */
  public onMouseLeave = (event: any): void => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.persist();

    /**
     * Afin d'améliorer la performance de l'interface on utilise des actions
     * espacé dans le temps
     */
    this.debouceMouseLeave();
  };
  /**
   * Changement des états des inputs
   * @method onSearchValue
   * @param { any }  event
   * @infos "https://reactdatepicker.com/"
   */
  public onSearchValue = (event: any): void => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.persist();

    {
      /** vérification de l'existence de l'élement  */
    }
    if (!Lodash.isUndefined(this.props.selectedOptions)) {
      /**
       * @constant
       * @name selectedOptions
       * @type any[]
       */
      let selectedOptions: any[] = []; // Création d'un nouveau tableau
      selectedOptions = this.props.selectedOptions.filter(
        (elem: any) =>
          elem.toLowerCase().indexOf(event.target.value.toLowerCase()) !== -1
      );

      {
        /** Empêcher la mutation du state */
      }

      this.setState((state: any): any => ({ selectedOptions }));
    }
  };
  /**
   * Changement des etats des inputs
   * @method onGetStringValue
   * @param { any }  event
   * @infos "https://reactdatepicker.com/"
   */
  public onGetStringValue = (param: string) => (event: any): void => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.preventDefault();

    const index: number = this.state.selectedFixeArray.indexOf(param);

    /**
     * @constant
     * @name filter
     * @type boolean[]
     */
    const filter: boolean[] = this.state.filter;
    /**
     * @constant
     * @name selectedString
     * @type boolean[]
     */
    const selectedString: any[] = this.state.selectedString;

    filter[index] = !filter[index];

    if (filter[index] === true) {
      selectedString[index] = param;
    } else {
      selectedString[index] = "";
    }
    /**
     * Afin d'améliorer la performance de l'interface on utilise des actions
     * espacées dans le temps
     */
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any) => filter);
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any) => selectedString);
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any) => ({ selected: !this.state.selected }));
  };
  /**
   * Cycle de vie d'un composant react
   * @method
   * @name componentWillReceiveProps
   * @description : La méthode  est appelée uniquement lorsque les props
   * ont changé et lorsqu'il ne s'agit pas d'un rendu initial
   * Le composant passe par une autre série d’étapes lorsque son parent refait son rendu
   * C’est l’endroit idéal pour vérifier si vos props vont changer par exemple
   * @param { any } nextProps
   * @infos "https://reactjs.org"
   */
  public componentWillReceiveProps(nextProps: any) {
    {
      /** Comparaison */
    }
    if (nextProps.selectedOptions !== this.props.selectedOptions) {
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any): any => ({
        selectedFixeArray: nextProps.selectedOptions,
        selectedOptions: Utils.transformObjectToArray(
          nextProps.selectedOptions
        ),
      }));
    }
  }

  /**
   * Cycle de vie d'un composant react
   * @method
   * @name componentDidUpdate
   * @description : La méthode  est appelée uniquement lorsque les props
   * ont changé et lorsqu'il ne s'agit pas d'un rendu initial
   * Le composant passe par une autre série d’étapes lorsque son parent refait son rendu
   * C’est l’endroit idéal pour vérifier si vos props vont changer par exemple
   * @param { any } prevProps
   * @param { any } prevState
   * @infos "https://reactjs.org"
   */
  public componentDidUpdate(prevProps: any, prevState: any) {
    {
      /** Comparaison des props */
    }
    // la fonction qui recupère le tableau

    if (prevState.selected !== this.state.selected) {
      if (!Lodash.isUndefined(this.state.selectedString)) {
        this.props.onGetSomeString(
          this.state.selectedString.filter((elem: any): any => elem !== "")
        );
      }
    } else if (prevProps.selectedValueProps !== this.props.selectedValueProps) {
      if (Lodash.isEqual(this.props.selectedValueProps, "noData")) {
        /**
         * @constant
         * @name filter
         * @type boolean[]
         */
        const filter: boolean[] = [];
        /**
         * @constant
         * @name selectedString
         * @type any[]
         */
        const selectedString: any[] = [];
        // boucle
        for (
          let i = 0;
          i < Math.ceil(this.state.selectedFixeArray.length);
          i++
        ) {
          filter[i] = false;
          selectedString[i] = "";
        }
        {
          /** Empêcher la mutation du state */
        }

        this.setState((state: any) => ({
          filter,
          selectedString,
          selected: !this.state.selected,
        }));
      }
    }
  }
  /**
   * Cycle de vie d'un composant react
   * @method
   * @name componentWillUnmount
   * @description : il est appelée.
   * Avant que le composant soit supprimé du DOM.
   * Cette méthode peut être utile lorsque vous devez effectuer
   * des opérations de nettoyage.
   * @param { void }
   * @infos "https://reactjs.org"
   */
  public componentWillUnmount() {
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({
      isVisible: false,
      filter: [],
      selectedString: [], // liste des eléments
      selectedOptions: [],
      toggleSusggestion: true,
    }));

    // Stopper l'action une fois le component détruit
    this.debouceMouseEnter.cancel();
    // Stopper l'action une fois le component détruit
    this.debouceMouseLeave.cancel();
    // Stopper l'action une fois le component détruit
    this.debouceToggleSuggestion.cancel();
  }
  /**
   * Cycle de vie d'un composant react
   * @method
   * @name render
   * @description : il est appelée. Pour le rendu ,
   * Ici le DOM virtuel fusionne avec le DOM réel
   * @param {  }
   * @infos "https://reactjs.org"
   */
  public render() {
    return (
      <Component
        onMouseLeave={this.onMouseLeave}
        onMouseEnter={this.onMouseEnter}
        onGetStringValue={this.onGetStringValue}
        onSearchValue={this.onSearchValue}
        onToggleSuggestion={this.onToggleSuggestion}
        onClearAllElement={this.onClearAllElement}
        onClearElement={this.onClearElement}
        {...this.props}
        {...this.state}
      />
    );
  }
}

{
  /** exporter le HOC : connect */
}
export default connect(null, {})(Container);



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@sharded/@widgets/filtre-multiple/container.tsx